import { tzParseTimezone as i } from "../_lib/tzParseTimezone/index.js";
import { toDate as T } from "../toDate/index.js";
function g(t, s, n) {
  t = T(t, n);
  const r = i(s, t, !0), e = new Date(t.getTime() - r), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()), o.setHours(e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()), o;
}
export {
  g as toZonedTime
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns-tz@3.2.0_date-fns@3.6.0/~/date-fns-tz/dist/esm/toZonedTime/index.js
// module id = 1336
// module chunks = 41